import { message } from "antd";

export function success(msg: string) {
  message.success(msg, 3).then();
}

export function error(msg: any) {
  message.error(msg, 3).then();
}

export function warn(msg: any) {
  message.warn(msg, 3).then();
}
